module.exports = __webpack_public_path__ + "img/t2.d7c5fa40.jpg";